<template>
  <v-container>
    <v-card max-width="600" class="mx-auto mt-5">
      <v-card-title>
        <span class="text-h5">Ladda upp CSV-fil för Exponeringsutrustning</span>
      </v-card-title>
      
      <v-card-text>
        <v-file-input
          v-model="selectedFile"
          accept=".csv"
          label="Välj fil"
          prepend-icon="mdi-paperclip"
          show-size
          clearable
          :disabled="uploading"
          @change="handleFileChange"
        />

        <v-alert
          v-if="message"
          :type="messageType"
          dismissible
          class="alert-message"
          @input="message = ''"
        >
          {{ message }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!selectedFile || uploading"
          :loading="uploading"
          @click="uploadFile"
        >
          <v-icon left>
            mdi-upload
          </v-icon>
          Ladda upp
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Optional: Show uploaded data in a table -->
    <v-card v-if="uploadedData.length > 0" max-width="1200" class="mx-auto mt-5">     
      <v-card-title>
        <span class="text-h6">Uppladdade beställningar- Ej EDI({{ uploadedData.length }})</span>
        <v-toolbar flat>
          <v-spacer />      
          <v-btn
            color="primary"
            dark
            class="mb-2"                    
            @click="invoice"
          >
            Lägg till i fakturering
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="uploadedData"
          :items-per-page="10" 
          group-by="importedInvoiceFileId"             
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, -1],
            'items-per-page-text': 'Rader per sida:'
          }"
        >
          <template v-slot:group.header="{ group }">                  
            <td colspan="15" class="group-header-cell">              
              <div class="d-flex justify-space-between align-center px-2">
                <div>                  
                  <span>Faktura fil nr:{{ group }} ({{ getGroupItemCount(group) }} poster)</span>
                  <span>Total: {{ calculateGroupTotal(group) }} kr</span>
                </div>
                <span>
                  <v-btn
                    small
                    color="primary"
                    dark
                    @click="deleteItemGroup(group)"
                  >
                    Radera fil
                    <v-icon
                      small
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </v-btn></span>
              </div>
            </td>                  
          </template>
          <template v-slot:item.orderDate="{ item }">
            {{ new Date(item.orderDate).toLocaleDateString('sv-SE') }}
          </template>
          <template v-slot:item.price="{ item }">
            {{ item.price.toLocaleString('sv-SE', { minimumFractionDigits: 2 }) }} kr
          </template>
          <template v-slot:item.ledger="{ item }">
            {{ item.ledger|ledgerToString }}
          </template>
          <template v-slot:item.id="{ item }">
            <v-icon
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
      <v-dialog v-model="dialogDelete" max-width="600px">
        <v-card>
          <v-card-title class="text-h5">
            Är du säker att du vill radera? <br>
          </v-card-title>
          <v-card-subtitle class="pt-2">
            <span class="text-subtitle-2">{{ dialogDeleteText }}</span>
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="closeDelete">
              Cancel
            </v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">
              OK
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import log from '@/logger'
import adminApi from '@/backend/adminapi'
export default {
  name: 'InvoiceUpload',
  data() {
    return {
      selectedFile: null,
      uploading: false,
      dialogDelete: false,
      dialogDeleteText:'',
      fileId:-1,
      editedItem: {},
      editedIndex: -1,
      message: '',
      messageType: 'info',
      uploadedData: [],
      headers: [
        { text: 'Kundnummer', value: 'customerNumber' },
        { text: 'Orderdatum', value: 'orderDate' },
        { text: 'Artikelnummer', value: 'articleNumber' },
        { text: 'Artikelbenämning', value: 'articleDescription' },
        { text: 'Antal', value: 'amount' },
        { text: 'Pris', value: 'price' },
        { text: 'Tidning', value: 'ledger' },
        { text: '', value: 'id' }
      ]
    }
  },
   mounted() {
    this.loadData()
  },
  methods: {  
    loadData() {
      adminApi.adminGetUploadedInvoice()
       .then((resp) => {          
          log.debug('Wating uploaded invoices:' + resp.data)
          this.uploadedData = resp.data                          
        })
        .catch((error) => {
          this.loading = false
          log.debug('Error - Getting uploaded invoices:', error)
        })        
    },
    handleFileChange(file) {
      this.message = ''
      this.uploadedData = []
      this.selectedFile = file
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.message = 'Vänligen välj en fil först'
        this.messageType = 'warning'
        return
      }

      const formData = new FormData()
      formData.append('file', this.selectedFile)

      this.uploading = true
      this.message = ''

      adminApi.adminUploadInvoice(formData)
        .then((resp) => {
          log.debug('File uploaded successfully:', resp.data)
          this.message = `Framgång! ${resp.data.count} beställningar har bearbetats.\r\n${resp.data.message}`
          
          this.messageType = 'success'
          //this.uploadedData = resp.data.data || []
          this.selectedFile = null
          this.loadData()
        })
        .catch((error) => {
          log.debug('Error uploading file:', error)
          this.message = `Fel: ${error.message || 'Något gick fel vid uppladdning'}\r\n${error.response?.data?.message || ''}`
          this.messageType = 'error'
        })
        .finally(() => {
          this.uploading = false
        })           
    },
    async invoice() {

      this.message = ''

      adminApi.adminTransferUploadToInvoice()
        .then((resp) => {
          log.debug('Transfer upload to invoice:', resp.data)
          this.message = `Framgång! Överföring till fakturering lyckades.\r\n${resp.data.message}`
          this.messageType = 'success'         
           this.loadData()
           this.$emit('invoice-uploaded') // Emit event when transfer is successful
        })
        .catch((error) => {
          log.debug('Error Transfer upload to invoice:', error)
          this.message = `Fel: ${error.message || 'Något gick fel vid Överföring till fakturering'}\r\n${error.response?.data?.message || ' '}`
          this.messageType = 'error'
        })
        .finally(() => {
          this.uploading = false
        })           
    }, 
    deleteItem(item) {
      this.editedIndex = this.uploadedData.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
      this.dialogDeleteText=`${item.articleDescription} för kund ${item.customerNumber}`
    },       
    deleteItemConfirm() {
      if(this.fileId!=-1){
        this.deleteItemGroupConfirm()        
      }
      else {
        adminApi.adminDeleteUploadedInvoice(this.editedItem)
        .then(()=>{  
          this.uploadedData.splice(this.editedIndex, 1)      
      
          this.editedItem = {}
          this.editedIndex = -1
          this.fileId=-1
          this.dialogDeleteText=''
        
        })
        .catch(error => {          
          log.debug('Errors:', error)
        })
      }
      this.closeDelete()
    },
    closeDelete() {
      this.dialogDelete = false

     
  },
    deleteItemGroup(group) {            
      this.dialogDelete = true
      this.dialogDeleteText=`Alla poster för faktura fil nr: ${group}`
      this.fileId = group
    },
   deleteItemGroupConfirm() {    
      adminApi.adminDeleteUploadedInvoiceFile(this.fileId)
      .then(()=>{  
        this.loadData()
        this.editedItem = {}
        this.editedIndex = -1
        this.fileId=-1
        this.dialogDeleteText=''    
      })
      .catch(error => {          
        log.debug('Errors:', error)
      })

      this.closeDelete()
      
    },
   getGroupItemCount(groupId) {
      return this.uploadedData.filter(item => item.importedInvoiceFileId === groupId).length
    },
    calculateGroupTotal(groupId) {
      return this.uploadedData
        .filter(item => item.importedInvoiceFileId === groupId)
        .reduce((total, item) => total + (item.price || 0) * (item.amount || 0), 0)
        .toFixed(2)
    },

  }
}
</script>

<style scoped>
/* Add these new styles */
.d-flex {
  display: flex !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

td {
  white-space: nowrap;
}

.alert-message {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.group-header-cell {
  width: 100%;
  padding: 8px 0;
  background-color: #f5f5f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  span{
    font-size: 1rem;
    font-weight: 300;
  }
}

.v-data-table ::v-deep .group-header-cell {
  white-space: normal !important;
  width: 100% !important;
  span{
    font-size: 1rem;
    font-weight: 300;
  }
}
</style>